<template>
  <div class="col-md-4 col-sm-12 p-0 accordion" style="max-width: 100%; width: 100%" role="tablist">
    <b-card-header :id="'parentHeader' + children.id" header-tag="header" class="p-1 bg-white" role="tab">
      <b-button :id="'parentButton' + children.id" class="custom-btn" size="sm"
                v-b-toggle="'parentAccordion-'+ children.id"
                @click="changeDirectAccessVisibility(false),
                                  setProductBreadcrumb(children.name),
                                  setProductListToEmpty(),
                                  setProductSizeToEmpty(),
                                  changeCollapseStateParent(),
                                  addCssToClickedElement('parentCaret' + children.id, 'parentButton' + children.id, 'parentHeader' + children.id)">
        <b-icon-caret-down-fill rotate="-90" :id="'parentCaret' + children.id" class="p-0 mr-1 caret-mb caret-transition" font-scale="0.99"/>
        {{children.name}}</b-button>
    </b-card-header>
    <b-collapse :id="'parentAccordion-'+ children.id"
                accordion="parentAccordion"
                role="tabpanel"
                v-on:hidden="removeCssFromElement('parentCaret' + children.id, 'parentButton' + children.id, 'parentHeader' + children.id)"
                v-if="productTreeVisibility">
      <b class="card-text" v-for="childOne in children.children" :key="childOne.id">
        <b-card-header :id="'headerChildOne' + childOne.id" header-tag="header" class="p-1 bg-white " role="tab">
          <b-button :id="'btnChildOne' + childOne.id" class="custom-btn" size="sm"
                    :style="indent(1)"
                    v-b-toggle="'childOneAccordion-' + childOne.id "
                    @click="changeDirectAccessVisibility(false),
                                              setProductBreadcrumb(children.name + ' / '+childOne.name),
                                              setProductListToEmpty(),
                                              setProductSizes(childOne.id),
                                              addCssToClickedElement('childOneCaret' + childOne.id, 'btnChildOne' + childOne.id, 'headerChildOne' + childOne.id)">
            <b-icon-caret-down-fill rotate="-90" :id="'childOneCaret' + childOne.id" class="p-0 mr-1 caret-mb caret-transition" font-scale="0.99"/>
            {{childOne.name}}
          </b-button>
        </b-card-header>
        <b-collapse :id="'childOneAccordion-' + childOne.id"
                    accordion="childOneAccordion"
                    role="tabpanel"
                    v-on:hidden="removeCssFromElement('childOneCaret' + childOne.id, 'btnChildOne' + childOne.id, 'headerChildOne' + childOne.id)">
          <b class="card-text" v-for="childTwo in childOne.children" :key="childTwo.id">
            <b-card-header :id="'headerChildTwo' + childTwo.id" header-tag="header" class="p-1 bg-white" role="tab">
              <b-button :id="'btnChildTwo' + childTwo.id" class="custom-btn" size="sm"
                        :style="indent(2)"
                        v-b-toggle="'childTwoAccordion-' + childTwo.id"
                        @click="changeDirectAccessVisibility(false),
                                                          setProductBreadcrumb(children.name + ' / '+childOne.name + ' / ' + childTwo.name),
                                                          setProductList(childTwo.children),
                                                          addCssToClickedElement('childTwoCaret' + childTwo.id, 'btnChildTwo' + childTwo.id, 'headerChildTwo' + childTwo.id)">
                <b-icon-caret-down-fill rotate="-90" :id="'childTwoCaret' + childTwo.id" class="p-0 mr-1 caret-mb caret-transition" font-scale="0.99"/>
                {{$t('tree-children.size')}} {{childTwo.name}}
              </b-button>
            </b-card-header>
            <b-collapse :id="'childTwoAccordion-' + childTwo.id"
                        accordion="childTwoAccordion"
                        role="tabpanel"
                        v-on:hidden="removeCssFromElement('childTwoCaret' + childTwo.id, 'btnChildTwo' + childTwo.id, 'headerChildTwo' + childTwo.id)">
              <b class="card-text" v-for="childThree in childTwo.children" :key="childThree.name + childThree.id">
                <b-card-header header-tag="header" class="p-1 bg-white" role="tab">
                  <b-button class="custom-btn" size="sm"
                            v-b-toggle="'childThreeAccordion-' + childThree.id"
                            :style="indent(3)"
                            @click="searchByMaxStklId(childThree.id),
                                                                      changeDirectAccessVisibility(false),
                                                                      setProductBreadcrumb(children.name + ' / ' + childThree.name.replace('/', ' / '))">
                    {{childThree.name}}
                  </b-button>
                </b-card-header>
              </b>
            </b-collapse>
          </b>
        </b-collapse>
      </b>
    </b-collapse>
  </div>
</template>

<script>

import searchByMaxStklId from "../../mixins/searchByMaxStklId";

export default {
  name: "TreeChildren",
  props: ['children'],
  mixins: [searchByMaxStklId],
  computed: {
    productTreeVisibility: function () {
      let visible = this.$store.getters.isProductTreeVisible;
      if(visible == false ){
        this.lookForCssAndRemove(this.children)
      }
      return visible;
    },
  },
  methods: {
    setProductBreadcrumb: function (product) {
      return this.$store.dispatch('setProductBreadcrumb', product);
    },
    indent(depth) {
      return { transform: `translate(${depth * 25}px`}
    },
    setProductList(productList) {
      return this.$store.dispatch('setProductList', productList);
    },
    changeDirectAccessVisibility(visible) {
      this.$store.dispatch('setDirectAccessVisibility', visible);
    },
    setProductListToEmpty() {
      this.$store.dispatch('setProductList', {})
    },
    setProductSizeToEmpty() {
      this.$store.dispatch('setProductSizes', {})
    },
    setProductSizes(modelid){
      this.$store.dispatch('setProductSizes', modelid);
    },
    changeCollapseStateParent() {
      if(this.productTreeVisibility == false){
        this.$store.dispatch('setProductTreeVisibility', true)
      }
    },
    lookForCssAndRemove(children){
      let caret = document.getElementById('parentCaret' + children.id);
      if(caret != null){
        if(caret.classList.contains('rotate-caret')){
          caret.classList.remove('rotate-caret')
        }
        caret = document.getElementById('parentHeader' + children.id)
        if(caret.classList.contains('bg-header')){
          caret.classList.remove('bg-header')
        }

        caret = document.getElementById('parentButton' + children.id)
        if(caret.classList.contains('chosen-element')){
          caret.classList.remove('chosen-element')
        }
      }

    },
    addCssToClickedElement(caretId, btnId, headerId){
      let caret = document.getElementById(caretId);
      caret.classList.add('rotate-caret');

      let btn = document.getElementById(btnId);
      btn.classList.add('chosen-element');

      let header = document.getElementById(headerId);
      header.classList.add('bg-header')

    },
    removeCssFromElement(caretId, btnId, headerId){
      let caret = document.getElementById(caretId);
      caret.classList.remove('rotate-caret');

      let btn = document.getElementById(btnId);
      btn.classList.remove('chosen-element');

      let header = document.getElementById(headerId);
      header.classList.remove('bg-header')
    },
  },
}
</script>

<style scoped>
.custom-btn {
  border: none;
  color: black;
  background-color: white;
  font-size: 14px;
}

.rotate-caret {
  transform: rotate(90deg);
}

.caret-transition {
  transition: transform 250ms;
}

.chosen-element {
  font-weight: bold !important;
  background-color: #f8f8f8 !important;
}

.bg-header{
  background-color: #f8f8f8  !important;
}

.caret-mb {
  position: relative;
  top: -2px;
}

</style>